export function fixedHeader() {

    let fixed = document.querySelector('[am-fixed]');

    window.addEventListener('scroll', function() {
        if (window.pageYOffset >= 40) {
            fixed.classList.add('nav-hidden');
            fixed.classList.add('is-active');
        } else {
            fixed.classList.remove('nav-hidden');
            fixed.classList.remove('is-active');
        }
    });

    fixed.addEventListener('mouseenter', function() {
        if (window.innerWidth > 999) {
            fixed.classList.remove('nav-hidden');
        }
    });

    fixed.addEventListener('mouseleave', function() {
        if (window.pageYOffset >= 40) {
            fixed.classList.add('nav-hidden');
        }
    });
}